export default {
  getActiveSection(state) {
    return state.activeSection;
  },
  getDevice(state) {
    return state.device;
  },
};
